import React from "react";
import PropTypes from "prop-types";
import Modal from "../modal";
import { Box, HStack, Text, VStack } from "native-base";
import { Link } from "react-router-dom";
import qs from "qs";
import colors from "../../constants/colors";
import styles from "./styles.module.css";
import routes from "../../routes";

function CreateAccountModal(props) {
  const { isOpen, onRequestClose } = props;

  return (
    <Modal maxWidth={600} isOpen={isOpen} onRequestClose={onRequestClose}>
      <VStack padding={5} space={5} textAlign="center">
        <Text fontSize="lg">
          ¡Hola! Para acceder a está sección necesitas tener una cuenta
        </Text>
        <HStack space={5}>
          <Link
            className={styles.flex}
            to={{
              pathname: routes.signUp,
              search: qs.stringify({
                url: location.pathname,
                action: "quotation",
              }),
            }}>
            <Box
              backgroundColor={colors.primary}
              paddingY={2}
              paddingX={8}
              borderRadius="full">
              <Text color={colors.white} textAlign="center">
                Crear cuenta
              </Text>
            </Box>
          </Link>
          <Link
            className={styles.flex}
            to={{
              pathname: routes.signIn,
              search: qs.stringify({
                url: location.pathname,
                action: "quotation",
              }),
            }}>
            <Box
              backgroundColor={colors.primary}
              paddingY={2}
              paddingX={8}
              borderRadius="full">
              <Text color={colors.white} textAlign="center">
                Ingresar
              </Text>
            </Box>
          </Link>
        </HStack>
      </VStack>
    </Modal>
  );
}

CreateAccountModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
};

export default CreateAccountModal;
